export const APP_TITLE = 'AlfaTex';

export const isActiveUser = (user) => user?.active !== false;

export const isAdminRole = (user) => isActiveUser(user) && user?.role === 'admin';

export const ADMIN_ACCESS_DENIED_MESSAGE =
  'Solo los usuarios con rol administrador pueden acceder a AlfaTex.';
